export function seedFromString(seed: string): number {
  let hash = 0x811c9dc5;
  for (let index = 0; index < seed.length; index += 1) {
    hash ^= seed.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }

  const normalized = hash >>> 0;
  return normalized === 0 ? 0x9e3779b9 : normalized;
}

export function nextRandom(state: number): { state: number; value: number } {
  let next = state >>> 0;
  next ^= next << 13;
  next ^= next >>> 17;
  next ^= next << 5;
  next >>>= 0;
  if (next === 0) next = 0x9e3779b9;

  return {
    state: next,
    value: next / 0x1_0000_0000,
  };
}

export function randomInt(
  state: number,
  minimum: number,
  maximum: number,
): { state: number; value: number } {
  const result = nextRandom(state);
  return {
    state: result.state,
    value: minimum + Math.floor(result.value * (maximum - minimum + 1)),
  };
}

export function shuffle<T>(state: number, values: readonly T[]): { state: number; values: T[] } {
  const shuffled = [...values];
  let cursor = state;

  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const roll = randomInt(cursor, 0, index);
    cursor = roll.state;
    const other = shuffled[roll.value];
    const current = shuffled[index];
    if (other === undefined || current === undefined) continue;
    shuffled[index] = other;
    shuffled[roll.value] = current;
  }

  return { state: cursor, values: shuffled };
}
